import React, { Component } from 'react'
import DatePicker from 'react-datepicker';
import moment from "moment";
import 'react-datepicker/dist/react-datepicker.css';
import { Link } from 'react-router-dom'
import log from '../../../helpers/logger'
import { auth, getCurrentUser } from '../../../helpers/auth'
import { getTimeStamp, getUUIDV4 } from '../../../helpers/utils'
import {
  createMagazine,
  updateMagazine,
  getMagazine,
  deleteMagazine } from '../../../services/MagazineService'

function setErrorMsg(error) {
  return {
    errorMsg: error.message
  }
}

export default class MagazinePageEdit extends Component {

  constructor(props) {
    super(props);
    this.state = {

      magazine_uuid: '',
      publisher_id: '',
      owner_id: '',
      tag: '',
      title: '',
      description: '',
      latest_issue_id: '',
      is_publish: '',
      sort_order: '',
      share_text: '',
      embed_html: '',
      date_created: '',
      status: '',

      errorMsg: null,
      currentUser: null,
      isLoading: true
    };

    this.handleDateChange = this.handleDateChange.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);

  }

  componentWillMount() {
    log.debug('componentWillMount')
  }
  async componentDidMount(){
    log.debug('componentDidMount')
    let user = await getCurrentUser();
    this.setState({currentUser: user})

    // load info
    let magazine = await getMagazine(this.props.match.params.id)
    log.debug(magazine)

    this.setState({magazineId: this.props.match.params.id})
    this.setState({

      magazine_uuid: magazine.magazine_uuid === undefined ? '' : magazine.magazine_uuid,
      publisher_id: magazine.publisher_id === undefined ? '' : magazine.publisher_id,
      owner_id: magazine.owner_id === undefined ? '' : magazine.owner_id,
      tag: magazine.tag === undefined ? '' : magazine.tag,
      title: magazine.title === undefined ? '' : magazine.title,
      description: magazine.description === undefined ? '' : magazine.description,
      latest_issue_id: magazine.latest_issue_id === undefined ? '' : magazine.latest_issue_id,
      is_publish: magazine.is_publish === undefined ? '' : magazine.is_publish,
      sort_order: magazine.sort_order === undefined ? '' : magazine.sort_order,
      share_text: magazine.share_text === undefined ? '' : magazine.share_text,
      embed_html: magazine.embed_html === undefined ? '' : magazine.embed_html,
      date_created: magazine.date_created === undefined ? '' : magazine.date_created,
      status: magazine.status === undefined ? '' : magazine.status,

      })
    // setup for moment DatePicker
    this.setState({date_created: moment(magazine.date_created)})

    log.debug(this.state)

    log.debug('all data is loaded.')
    this.setState({isLoading: false})
  }

  handleDateChange(date) {
    this.setState({
      date_created: date
    });
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    // bind all input to setState
    this.setState({
      [name]: value
    });
    log.debug(this.state)

  }

  async handleSubmit(event) {
    event.preventDefault();

    log.debug(this.state.date_created.toDate())

    let magazine = {

      magazine_uuid: this.state.magazine_uuid ,
      publisher_id: this.state.publisher_id ,
      owner_id: this.state.owner_id ,
      tag: this.state.tag ,
      title: this.state.title ,
      description: this.state.description ,
      latest_issue_id: this.state.latest_issue_id ,
      is_publish: this.state.is_publish ,
      sort_order: this.state.sort_order ,
      share_text: this.state.share_text ,
      embed_html: this.state.embed_html ,
      date_created: this.state.date_created.toDate(),
      status: this.state.status ,
    }
    log.debug(magazine)

    try{
      let result = await updateMagazine(this.state.magazineId, magazine)
      log.debug('update success')
      //redirect to view
      this.props.history.push(`/magazine/view/${this.state.magazineId}`)
    }catch (err) {
      log.debug(err)
      this.setState(setErrorMsg(err))
    }

  }

  render () {

    let content;

    if (this.state.isLoading) {
      content = <div>Loading...</div>;
    } else {
      content =
      <div>
        <h4 className="page-header">
          <Link to='/magazine'>Magazine</Link> -> &nbsp;
          <Link to={`/magazine/view/${this.state.magazineId}`}>{this.state.title}</Link>  ->&nbsp;
          Edit
        </h4>
        <form className="form-horizontal" role="form" onSubmit={this.handleSubmit}>

          {
            this.state.registerError &&
          <div className="form-group">
            <div className="col-sm-offset-2 col-sm-10">
              <div className="alert alert-danger" role="alert">
              <span className="sr-only">Error:</span>
              &nbsp;{this.state.registerError}
              </div>
            </div>
          </div>
          }


          <div className="form-group">
            <label htmlFor="magazine_uuid" className="col-sm-2 control-label">magazine_uuid:</label>
            <div className="col-sm-4">
              <input className="form-control"
                type="text"
                name="magazine_uuid"
                value={this.state.magazine_uuid}
                onChange={this.handleInputChange}
                placeholder="magazine_uuid" readOnly/>
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="publisher_id" className="col-sm-2 control-label">publisher_id:</label>
            <div className="col-sm-4">
              <input className="form-control"
                type="text"
                name="publisher_id"
                value={this.state.publisher_id}
                onChange={this.handleInputChange}
                placeholder="publisher_id" readOnly/>
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="owner_id" className="col-sm-2 control-label">owner_id:</label>
            <div className="col-sm-4">
              <input className="form-control"
                type="text"
                name="owner_id"
                value={this.state.owner_id}
                onChange={this.handleInputChange}
                placeholder="owner_id" readOnly/>
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="tag" className="col-sm-2 control-label">tag:</label>
            <div className="col-sm-4">
              <input className="form-control"
                type="text"
                name="tag"
                value={this.state.tag}
                onChange={this.handleInputChange}
                placeholder="tag"/>
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="title" className="col-sm-2 control-label">title:</label>
            <div className="col-sm-4">
              <input className="form-control"
                type="text"
                name="title"
                value={this.state.title}
                onChange={this.handleInputChange}
                placeholder="title"/>
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="description" className="col-sm-2 control-label">description:</label>
            <div className="col-sm-4">
              <textarea className="form-control"
                //type="text"
                name="description"
                value={this.state.description}
                onChange={this.handleInputChange}
                placeholder="description"/>
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="latest_issue_id" className="col-sm-2 control-label">latest_issue_id:</label>
            <div className="col-sm-4">
              <input className="form-control"
                type="text"
                name="latest_issue_id"
                value={this.state.latest_issue_id}
                onChange={this.handleInputChange}
                placeholder="latest_issue_id"/>
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="is_publish" className="col-sm-2 control-label">is_publish:</label>
            <div className="col-sm-4">
              <input className="form-control"
                type="text"
                name="is_publish"
                value={this.state.is_publish}
                onChange={this.handleInputChange}
                placeholder="is_publish"/>
            </div>***[ YES || NO ]
          </div>
          <div className="form-group">
            <label htmlFor="sort_order" className="col-sm-2 control-label">sort_order:</label>
            <div className="col-sm-4">
              <input className="form-control"
                type="text"
                name="sort_order"
                value={this.state.sort_order}
                onChange={this.handleInputChange}
                placeholder="sort_order"/>
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="share_text" className="col-sm-2 control-label">share_text:</label>
            <div className="col-sm-4">
              <textarea className="form-control"
                //type="text"
                name="share_text"
                value={this.state.share_text}
                onChange={this.handleInputChange}
                placeholder="share_text"/>
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="embed_html" className="col-sm-2 control-label">embed_html:</label>
            <div className="col-sm-4">
              <textarea className="form-control"
                //type="text"
                name="embed_html"
                value={this.state.embed_html}
                onChange={this.handleInputChange}
                placeholder="embed_html"/>
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="date_created" className="col-sm-2 control-label">date_created:</label>
            <div className="col-sm-4">
              <DatePicker
                className="form-control"
                type="text"
                name="date_created"
                selected={this.state.date_created}
                onChange={this.handleDateChange}
                // showTimeSelect
                dateFormat="DD/MM/YYYY h:mm"
              />
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="status" className="col-sm-2 control-label">status:</label>
            <div className="col-sm-4">
              <input className="form-control"
                type="text"
                name="status"
                value={this.state.status}
                onChange={this.handleInputChange}
                placeholder="status"/>
            </div>
          </div>

          {/* <div className="form-group">
            <label htmlFor="date_created" className="col-sm-2 control-label">date_created:</label>
            <div className="col-sm-4">
              <DatePicker
                className="form-control"
                type="text"
                name="date_created"
                selected={this.state.date_created}
                onChange={this.handleDateChange}
                // showTimeSelect
                dateFormat="DD/MM/YYYY h:mm"
              />
            </div>
          </div> */}

          <div className="form-group">
            <div className="col-sm-offset-2 col-sm-10">
              <button type="submit" className="btn btn-primary">Edit</button>
            </div>
          </div>

        </form>
      </div>
    }


    return (
      <div>
          {content}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/MagazinePage/MagazinePageEdit.js